import {JsonEditor} from "jsoneditor-react";
import React, {useRef, useEffect} from "react";

function JsonInput({ value = {}, options, onChange, onInvalidValue }) {
  const editorRef = useRef(null);

  const handleInvalidValue = onInvalidValue || (onChange => onChange(""));

  const triggerChange = (changedValue) => {
    onChange(changedValue);
  };

  useEffect(() => {
    const handleCopy = (e) => {
      if (!editorRef.current) return;
      
      const editor = editorRef.current.jsonEditor;
      if (!editor) return;

      const aceEditor = editor.aceEditor;
      if (!aceEditor) return;

      const selectedText = aceEditor.getSelectedText();
      if (selectedText) {
        e.preventDefault();
        e.stopPropagation();
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', selectedText);
        }
      }
    };

    const editorElement = editorRef.current?.jsonEditor?.aceEditor?.container;
    const addListener = () => editorElement?.addEventListener('copy', handleCopy, true);
    const removeListener = () => editorElement?.removeEventListener('copy', handleCopy, true);

    addListener();
    return removeListener;
  }, []);

  return (
    <JsonEditor 
      {...options} 
      value={value}
      onChange={val => triggerChange(val)}
      onValidationError={errs => {
        if (errs.length > 0) {
          handleInvalidValue(onChange);
        }
      }}
      ref={editorRef}
    />
  )
}

export default JsonInput;
